import React, { useState } from 'react';

import { Container } from '../../../components';
import { useAppDispatch } from '../../../store';
import { addConsultant } from '../../../store/actions/consultant';
import UserForm from '../components/user-form';
import { AddConsultantParams } from '../../../types/consultant';
import styles from './styles';

export default function NewConsultant() {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data: AddConsultantParams) => {
    setLoading(true);
    await dispatch(addConsultant(data));
    setLoading(false);
  };

  return (
    <Container
      flexGrow
      spacingHorizontal="medium"
      spacingVertical="medium"
      style={styles.container}>
      <UserForm loading={loading} onSubmit={onSubmit} />
    </Container>
  );
}
